import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { WhoItIsFor } from '../components/WhoItIsFor';
import { DatabaseReactivation } from '../components/DatabaseReactivation';
import { ProjectMenu } from '../components/ProjectMenu';
import { CtaBand } from '../components/CtaBand';
import { usePageTitle } from '../hooks/usePageTitle';
export function WhoItsForPage() {
  usePageTitle('Who It Is For | Viridia Analytics');
  return <>
      <PageHeader eyebrow="Who it is for" title="Built for teams with real lead spend and no time to answer the phone." body="Team leads and broker owners running Premier Agent, Flex, Realtor.com, sign calls, and their own website traffic. If appointments are the bottleneck, this is the fix." data-id="element-576" data-mp="xts69gy3vrsb" />
      <WhoItIsFor data-id="element-577" data-mp="38mmq3l1qvvbh" />
      <DatabaseReactivation data-id="element-578" data-mp="38n4ig6ladpe4" />
      <ProjectMenu data-id="element-579" data-mp="38ne81t2f5uja" />
      <CtaBand title="Find out how many appointments your team is leaving on the table." body="We will show you the missed-lead math for your own team, plus what your unworked database is likely holding." data-id="element-580" data-mp="38nxot6gc2cvq" />
    </>;
}